import { render, staticRenderFns } from "./FloatingProduction.vue?vue&type=template&id=168f16dc&scoped=true"
import script from "./FloatingProduction.vue?vue&type=script&lang=js"
export * from "./FloatingProduction.vue?vue&type=script&lang=js"
import style0 from "./FloatingProduction.vue?vue&type=style&index=0&id=168f16dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168f16dc",
  null
  
)

export default component.exports